import { style, styleVariants } from '@vanilla-extract/css';
import { borderWidthVars } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';

const ICON_PX = '24px';
const HERO_ICON_PX = '80px';

export const iconBaseClass = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
  verticalAlign: '-0.125em',
});

export const clickableClass = style({
  cursor: 'pointer',
  selectors: {
    '&:focus-visible': {
      outline: `${borderWidthVars.xs} solid ${semanticTokenVars.border.brand.base}`,
      outlineOffset: '1px',
    },
  },
});

export const rotationClass = styleVariants({
  '0': { transform: 'rotate(0deg)' },
  '90': { transform: 'rotate(90deg)' },
  '180': { transform: 'rotate(180deg)' },
  '270': { transform: 'rotate(270deg)' },
});

export const sizeClass = styleVariants({
  default: { fontSize: ICON_PX },
  hero: { fontSize: HERO_ICON_PX },
});
